export { default } from './SignerTypeExtendedConfig';
